import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "hamburger", "close"]
  
  connect() {
    // Initialize menu in closed state
    this.close()
  }
  
  toggle() {
    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }
  
  open() {
    this.menuTarget.classList.remove('hidden')
    if (this.hasHamburgerTarget) {
      this.hamburgerTarget.classList.add('hidden')
    }
    if (this.hasCloseTarget) {
      this.closeTarget.classList.remove('hidden')
    }
  }
  
  close() {
    this.menuTarget.classList.add('hidden')
    if (this.hasHamburgerTarget) {
      this.hamburgerTarget.classList.remove('hidden')
    }
    if (this.hasCloseTarget) {
      this.closeTarget.classList.add('hidden')
    }
  }
}